import { data } from '../../svg/FormatBold/data';
import { makeIcon } from '../makeIcon';

export const FormatBold = makeIcon(data, 'format_bold', 'FormatBold');

export default FormatBold;
